module.exports = __webpack_public_path__ + "img/avatar2.0114f1c6.png";